import React from 'react';
import { Card as MuiCard, CardContent, Typography, Box } from '@mui/material';

function Card({ children, title, headerAction, gradient = false, sx: sxOverride = {}, contentSx = {} }) {
  return (
    <MuiCard 
      className="mb-5"
      sx={{
        boxShadow: 'none',
        borderRadius: '12px',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        transition: 'all 0.2s ease',
        '&:hover': {
          border: '1px solid rgba(59, 130, 246, 0.3)',
        },
        background: '#1e293b',
        overflow: 'hidden',
        ...sxOverride,
      }}
    >
      {title && (
        <Box 
          className="flex justify-between items-center px-6 pt-6 pb-4"
          sx={{
            borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
          }}
        >
          <Typography 
            variant="h2" 
            component="h2"
            className="font-bold"
            sx={{
              color: '#e2e8f0',
              fontSize: '1.25rem',
              fontWeight: 700
            }}
          >
            {title}
          </Typography>
          {headerAction && (
            <Box>{headerAction}</Box>
          )}
        </Box>
      )}
      <CardContent className="px-6 pb-6" sx={{ overflow: 'hidden', ...contentSx }}>
        {children}
      </CardContent>
    </MuiCard>
  );
}

export default Card;
